export default "<!-- content will be added dynamically -->\n"